var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.22 50.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3b51b;}.cls-2{fill:#4f515b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.92,35.82a15.2,15.2,0,1,1,15.2-15.19A15.2,15.2,0,0,1,25.92,35.82Zm0-25.84A10.65,10.65,0,1,0,36.57,20.63,10.67,10.67,0,0,0,25.92,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.38,50a9.38,9.38,0,1,1,9.38-9.38A9.39,9.39,0,0,1,9.38,50Zm0-14.22a4.84,4.84,0,1,0,4.83,4.84A4.84,4.84,0,0,0,9.38,35.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.33,
    cy: 4.89,
    r: 4.89
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayoLogo);
export default __webpack_public_path__ + "static/media/dayo-logo.833155649dba6c7a05a9ddb9559ae4db.svg";
export { ForwardRef as ReactComponent };